export const INIT_INPUTS = {
  departure: {
    lat: "",
    lng: "",
    address: "",
  },
  arrival: {
    lat: "",
    lng: "",
    address: "",
  },

  passengersCount: 1,
  taxi: "",
};

export const PASSENGER_INFO = {
  firstname: "",
  lastname: "",
  phone: "",
};
